/**
 * OptIn, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/OptInComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

import { reservedFieldNameErrors } from '../fieldName';

export const OptInCore = {
  type: 'OptIn',
  name: 'Opt In',
  icon: '✅',
  description: 'A single checkbox for consent, such as agreeing to terms.',
  category: 'selection',
  maxPerScreen: null,
  getDefaultProperties() {
    return {
      name: 'opt_in',
      label: 'I agree to the terms',
      required: false,
    };
  },
  getPropertySchema() {
    return {
      name: {
        type: 'string',
        label: 'Field Name',
        required: true,
      },
      label: {
        type: 'string',
        label: 'Label',
        required: true,
      },
      required: {
        type: 'boolean',
        label: 'Required',
        required: false,
      },
    };
  },
  validateProperties(properties) {
    const errors = [];
    const warnings = [];

    if (!properties.name || properties.name.trim().length === 0) {
      errors.push('Field name is required');
    }

    if (properties.name && !/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(properties.name)) {
      errors.push('Field name must start with letter or underscore');
    }

    errors.push(...reservedFieldNameErrors(properties.name));

    if (!properties.label || properties.label.trim().length === 0) {
      errors.push('Label is required');
    }

    return { errors, warnings };
  },
  transformToWhatsApp(properties) {
    return {
      type: 'OptIn',
      name: properties.name,
      label: properties.label,
      required: properties.required || false,
    };
  },
  transformFromWhatsApp(whatsappComponent) {
    return {
      name: whatsappComponent.name,
      label: whatsappComponent.label,
      required: whatsappComponent.required || false,
    };
  },
};
